export default {
    content: {
        display: "flex",
        flexDirection: "column",
        gap: 2
    },
    mainText: {
        marginBottom: 1
    },
    disclaimerText: {
        color: "greyscale.700",
        fontStyle: "italic"
    }
};
